import { render, staticRenderFns } from "./WatermarkDetectionResult.vue?vue&type=template&id=d534d8d8"
import script from "./WatermarkDetectionResult.vue?vue&type=script&lang=js"
export * from "./WatermarkDetectionResult.vue?vue&type=script&lang=js"
import style0 from "./WatermarkDetectionResult.vue?vue&type=style&index=0&id=d534d8d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports